export class PasswordPolicyError extends Error {
  name: string = "PasswordPolicyException";

  message =
    "Password must be at least 8 characters and have at least one number, upper case letter, lowercase letter, and special character";
}

export class UsernameExistsError extends Error {
  name: string = "UsernameExistsException";

  message = "An account with the given email already exists.";
}

export class ExpiredCodeError extends Error {
  name = "ExpiredCodeException";

  message = "Invalid code provided, please request a code again.";
}

export class CodeMismatchError extends Error {
  name = "CodeMismatchException";

  message = "Invalid verification code provided, please try again.";
}

export class ForgotPasswordSignInError extends Error {
  name = "ForgotPasswordSignInError";

  message = "Sign in failed after resetting password. Please try again.";
}

export class LimitExceededError extends Error {
  name = "LimitExceededException";

  message = "Attempt limit exceeded, please try after some time.";
}

export class UsernameIsEmailError extends Error {
  name = "UsernameIsEmailError";

  message = "Username can not be an email.";
}

export class NotAuthorizedError extends Error {
  name = "NotAuthorizedException";

  message = "Incorrect username or password.";

  constructor(message: string) {
    super();
    if (message === "Password attempts exceeded") {
      this.message = message;
    }
  }
}
